import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-date-range',
  templateUrl: './date-range.component.html',
  styleUrls: ['./date-range.component.scss']
})
export class DateRangeComponent implements OnInit {
  ranges = [
    ['Today', [moment(), moment()]],
    ['Yesterday', [moment().subtract(1, 'days'), moment().subtract(1, 'days')]],
    ['Last 7 Days', [moment().subtract(6, 'days'), moment()]],
    ['Last 30 Days', [moment().subtract(29, 'days'), moment()]],
    ['This Month', [moment().startOf('month'), moment().endOf('month')]],
    ['Last Month', [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]]
 ]
  constructor() { }

  ngOnInit(): void {
  }

}
